import { render } from "./remove_follower_button.vue?vue&type=template&id=3a720b99"
import script from "./remove_follower_button.js?vue&type=script&lang=js"
export * from "./remove_follower_button.js?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__